import PersonalProfile from "../../components/PersonalProfile";
import { order } from "../SmartSearchParammeter";

export default async function PersonalProfileSearchConfig(key) {
  return {
    description: "Personal Profile",
    id: "personalProfile",
    initial: undefined,
    type: order.third,
    handleValues: (searchObject) => {
      return;
    },

    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <PersonalProfile searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact", "Like"],
    list: [],

    handler: function (searchObj, value) {
      searchObj["personalProfile"] = value[0];
    }
  };
}
